import { render, staticRenderFns } from "./ThgQuoteDetailInformationContractCard.vue?vue&type=template&id=99789ade&"
import script from "./ThgQuoteDetailInformationContractCard.vue?vue&type=script&lang=ts&"
export * from "./ThgQuoteDetailInformationContractCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardText,VIcon})
